module.exports = __webpack_public_path__ + "static/media/remove-icon.8eb1839a.svg";